import {
  createLoadableState,
  LoadableState
} from '~/utils/store/concerns/loadable/state'

export interface Config {}

export interface NotLoadableState {
  config: null | Config
}
export interface State extends NotLoadableState, LoadableState {}

export default () =>
  createLoadableState({
    config: null
  })
